<template>
  <transition name="chatbot-btn">
    <v-btn v-if="!store.open" class="chatbot-fab" icon size="56" color="tertiary-900" elevation="8" @click="store.togglePanel()">
      <v-icon size="28" color="primary-900">mdi-robot-outline</v-icon>
    </v-btn>
  </transition>
</template>

<script setup lang="ts">
import { useChatbotStore } from "@/store/chatbot";

const store = useChatbotStore();
</script>

<style scoped>
.chatbot-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 2001;
}

.chatbot-btn-enter-active,
.chatbot-btn-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.chatbot-btn-enter-from,
.chatbot-btn-leave-to {
  opacity: 0;
  transform: scale(0.7);
}
</style>
